import _ from 'lodash';
import { ALL_VALUE } from 'containers/App/app.constants';
import { schema, normalize, denormalize } from 'normalizr';


/*
const type = new schema.Entity('types');
const family = new schema.Entity('families', {
	children: [type]
});

const family1 = new schema.Entity('family1s', {
	children: [family]
});

const treeNode = new schema.Entity('nodes');
treeNode.define({
	children: [treeNode]
});
*/


export const getHierarchyData = treeArr => {
	let idToLabelMap = {
		[ALL_VALUE]: ALL_VALUE
	};

	const buildTree = (arr, labelPrefix = '', level = 0) => {
		if (_.isEmpty(arr))
			return arr;

		return _.sortBy(
			_.map(arr, node => {
				const { id, label, assignableToGroup } = node;
				const title = label;
				const key = id;
				const value = id;
				const fullPath = labelPrefix + label;
				idToLabelMap[id] = fullPath;

				return {
					id,
					level,
					key,
					title,
					fullPath,
					value,
					assignableToGroup,
					children: buildTree(node.children, fullPath + '/', level + 1)
				}
			}),
			'title');
	};

	const tree = buildTree(treeArr);

	// const normalizedData = normalize(tree, [treeNode]);
	// const nodesById = normalizedData.entities.nodes;
	// const node = denormalize("9486e678-f42d-462d-9425-e5069881fc54", treeNode, normalizedData.entities);

	return { tree, idToLabelMap };
};

/**
 * Filters device types tree to only include branches with assignableToGroup: true at leaf nodes
 * @param {Array} treeData - The device types tree data
 * @returns {Array} - Filtered tree data
 */
export const filterDeviceTypesByAssignableToGroup = (treeData) => {
	if (_.isEmpty(treeData)) {
		return treeData;
	}

	return _.compact(
		_.map(treeData, node => {
			// If node has children, recursively filter them
			if (!_.isEmpty(node.children)) {
				const filteredChildren = filterDeviceTypesByAssignableToGroup(node.children);
				// Only include parent node if it has at least one child after filtering
				if (!_.isEmpty(filteredChildren)) {
					return {
						...node,
						children: filteredChildren
					};
				}
				return null;
			}
			// Leaf node: only include if assignableToGroup is true
			if (node.assignableToGroup === true) {
				return node;
			}
			return null;
		})
	);
};


